// Libs
import React, { useContext, useEffect, useState } from 'react';
import { Modal, Radio } from 'antd';

// Own Libs
import * as ui from '@digital/ui';

//Api
import { getItemsServico, getItemsServicoOptionByCodigo } from '@app/api/itemServico';

//Files

//Utils
import QuestionarioContextProvider from '@app/hooks/useQuestionario';
import { Col } from '@digital/ui';

interface ModalSelectItemServicoProps {
  // setItemServicoSelecionado: (itemServico: any) => void;
  disabled?: boolean;
  itemServicoSelecionado?: string;
  span?: React.ComponentProps<typeof Col>['span'];
}

function ModalSelectItemServico({ disabled, itemServicoSelecionado, span }: ModalSelectItemServicoProps) {
  const [exibirModalSelect, setExibirModalSelect] = useState(false);

  const {
    itemServicoOptions,
    setItemServicoOptions,
    itemServico,
    setItemServico,
  } = useContext(QuestionarioContextProvider);

  const [data, setData] = useState([]);
  const [codigo, setCodigo] = useState<string | null>(null);
  const [descricao, setDescricao] = useState<string | null>(null);

  const onPesquisar = () => {
    getItemsServico({ codigo, descricao }).then(async (response: any) => {
      setData(response);
    });
  };

  useEffect(() => {
    if (exibirModalSelect) {
      onPesquisar();
    }
  }, [exibirModalSelect]);

  useEffect(() => {
    getItemsServicoOptionByCodigo(itemServicoSelecionado || itemServico || '').then(options => {
      setItemServicoOptions(options);
    });
  }, [itemServico, itemServicoSelecionado]);

  const columns = [
    {
      title: '',
      dataIndex: 'id',
      render: (text: any, record: any) => (
        <Radio
          id={`mrn-radio-codItemServico-${record.id}`}
          key={record.id}
          name="codItemServico"
          value={record.codigo}
          checked={record.codigo === itemServico}
          onChange={e => setItemServico(e.target.value)}
        />
      ),
    },
    {
      title: 'Código',
      dataIndex: 'codigo',
    },
    {
      title: 'Descrição',
      dataIndex: 'descricao',
    },
  ];

  return (
    <>
      <ui.FormSelect
        options={itemServicoOptions}
        label="Item de Serviço"
        name="codItemServico"
        id='mrn-select-codItemServico'
        span={span || 8}
        open={false}
        value={itemServicoSelecionado || itemServico || ''}
        onDropdownVisibleChange={(open: any) => {
          if (open) setExibirModalSelect(open);
        }}
        disabled={disabled}
        required={itemServico === undefined}
      />
      {exibirModalSelect && (
        <Modal
          width="960px"
          title="Selecione o Item de Serviço"
          visible={exibirModalSelect}
          onCancel={() => setExibirModalSelect(false)}
          footer={[
            <ui.Button
              id='mrn-button-modal-ModalSelectItemServico-filter-ok'
              key="okButton"
              type={'primary'}
              onClick={() => {
                setExibirModalSelect(false);
              }}>
              OK
            </ui.Button>,
          ]}>
          <ui.MasterDetailForm>
            <ui.FilterWidget
              id="mrn-filter-modal-ModalSelectItemServico"
              title=" "
              actions={[
                <ui.Button key={'pesquisarButton'} type={'primary'} onClick={onPesquisar}>
                  Pesquisar
                </ui.Button>,
              ]}>
              <ui.FormInput
                id="mrn-input-modal-ModalSelectItemServico-codigo"
                name="filtroItemServicoCodigo"
                value={codigo || ''}
                span={6}
                label="Código"
                onChange={v => setCodigo(v.currentTarget.value)}
              />
              <ui.FormInput
                id="mrn-input-modal-ModalSelectItemServico-descricao"
                name="filtroItemServicoDescricao"
                value={descricao || ''}
                span={6}
                label="Descrição"
                onChange={v => setDescricao(v.currentTarget.value)}
              />
            </ui.FilterWidget>
            <ui.Table columns={columns} dataSource={data} pagination={false} style={{ padding: '0 5px' }} />
          </ui.MasterDetailForm>
        </Modal>
      )}
    </>
  );
}
export default ModalSelectItemServico;
